import { Box } from '@mui/material';

export const Rectangle = (props: { color: string; width?: string | number; height?: string | number }) => {
  const { color, width = '0.75rem', height = '0.75rem' } = props;

  return (
    <Box
      sx={{
        backgroundColor: color,
        width,
        height,
        borderRadius: '2px',
        display: 'inline-block',
        mr: 1,
        ml: 0.5,
        flexShrink: '0',
      }}
    />
  );
};
